// contexts/AuthContext.js (DOĞRU VE TAM HALİ)

import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { loginOwner as apiLogin, logout as apiLogout, verifySession as apiVerify } from '../services/apiService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkUserSession = async () => {
      try {
        const data = await apiVerify();
        if (data.user) {
          setUser(data.user);
        }
      } catch (error) {
        console.error("Oturum doğrulanamadı:", error.message);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    checkUserSession();
  }, []);

  const login = useCallback(async (email, password) => {
    const data = await apiLogin(email, password);
    setUser(data.user);
    localStorage.setItem('ownerPrimaryCode', data.primaryCode);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await apiLogout();
    } catch (error) {
      console.error("Çıkış sırasında hata:", error.message);
    } finally {
      setUser(null);
      localStorage.removeItem('ownerPrimaryCode');
      window.location.href = '/owner/login';
    }
  }, []);

  const value = React.useMemo(() => ({ user, loading, login, logout }), [user, loading, login, logout]);

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);